import { cn } from '@/lib/utils'

interface InventoryEmptyStateProps {
  title: string
  description: string
  className?: string
}

export function InventoryEmptyState({ title, description, className }: InventoryEmptyStateProps) {
  return (
    <div className={cn("flex flex-col items-center justify-center pt-8 pb-16 text-center", className)}>
      {/* Decorative only. The negative margins pull this 500px image OUT of its
          box, so it paints over whatever sits above the empty state — on the
          reconciliation page that's the filter row, and the image was
          swallowing every click on it (the filters looked dead). It must never
          receive pointer events. */}
      <div
        aria-hidden
        className="pointer-events-none relative w-[400px] h-[400px] sm:w-[500px] sm:h-[500px] opacity-60 shrink-0 -my-16 sm:-my-20 z-0"
      >
        <img
          src="https://cdn.rootpoint.io/platform/inventory-empty.png"
          alt=""
          className="pointer-events-none w-full h-full object-contain"
        />
      </div>
      <div className="flex flex-col gap-2 items-center z-10 relative">
        <p className="font-medium text-muted-foreground text-xl">{title}</p>
        <p className="text-sm text-muted-foreground max-w-sm text-balance">{description}</p>
      </div>
    </div>
  )
}
